import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-unsubscribe-marketing-emails',
    templateUrl: './unsubscribe-marketing-emails.component.html',
    styleUrls: ['./unsubscribe-marketing-emails.component.scss'],
    standalone: false
})
export class UnsubscribeMarketingEmailsComponent {
  constructor(private titleService: Title)
  {
    titleService.setTitle('Unsubscribe from Marketing Emails');
  }
}
